import { Injectable } from '@angular/core';
import { AppInsightsService } from '../../services/appInsights/appInsights.service';
import { LoggerService, ILogFn } from '../../services/logging/logger.service';
import { AppInjector } from '../../../app.injector';
import * as _ from 'underscore';

@Injectable()
export class QuerySort {

    constructor() {

    }

    getSortString(sortFields: any, isReversed: boolean): string {
        if (!sortFields)
            return '';

        if (typeof sortFields === 'string') {
            sortFields = sortFields.split(',');
        }

        if (!Array.isArray(sortFields)) {
            sortFields = [sortFields.toString()];
        }

        var desc = ((isReversed) ? ' desc' : '');
        return sortFields.join(desc + ',') + desc;
    }
}